import { throwError } from "rxjs";

import { Media } from "@skinsoft/types";
import { EntityDataStore } from "@skinsoft/entity-data-store";

export class MediaDataStore extends EntityDataStore<Media> {

    private static instance: MediaDataStore = null as any

    public static getInstance() {
        if (!MediaDataStore.instance) {
            MediaDataStore.instance = new MediaDataStore()
        }

        return MediaDataStore.instance
    }

    public static install(Vue) {
        Vue.prototype.$mediaDataStore = MediaDataStore.getInstance()
    }

    constructor() {
        super('medias', ['media'])
    }

    protected initializeDataFetcher() {
        //throw new Error("Method not implemented.");
    }

    protected initializeDataPusher() {
        //throw new Error("Method not implemented.");
    }

    public duplicate(entityToDuplicateId: string, createBody?: Partial<Media>, body?: Partial<Media>) {
        return throwError("Cannot duplicate medias")
    }
}